import { UploadService } from '../../../shared/services/upload.service';
import { Component, OnInit } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormBuilder,
  Validators,
} from '@angular/forms';
import { distinctUntilChanged, identity, of, switchMap, take, tap } from 'rxjs';
import { ProfessionalService } from '../../../shared/services/professional.service';
import { ZipcodeService } from '../../../shared/services/zipcode.service';
import { OccupationAreasService } from '../../../shared/services/occupation-areas.service';
import { SpecialtiesService } from '../../../shared/services/specialties.service';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { requiredFileType } from 'src/app/shared/validators/required-file-type.validator';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-create-professional',
  templateUrl: './create-professional.component.html',
  styleUrls: ['./create-professional.component.scss'],
})
export class CreateProfessionalComponent implements OnInit {
  employmentTypeOptions = [
    { value: 'service_provider', label: 'Prestador de Serviço' },
    { value: 'partner', label: 'Sócio' },
    { value: 'employee', label: 'CLT' },
  ];
  nationalities: any[] = [
    'Brasileiro',
    'Portuguesa',
    'Filipina',
    'Sul-Africano',
    'Zimbabweano',
    'Namibiana',
    'Boliviano',
    'Chileno',
    'Colombiano',
    'Costarriquenho',
    'Cubano',
    'Dominicano',
    'Equatoriano',
    'Salvadorenho',
    'Granadino',
    'Guatemalteco',
    'Guianês',
    'Guianense',
    'Haitiano',
    'Hondurenho',
    'Jamaicano',
    'Mexicano',
    'Nicaraguense',
    'Panamenho',
    'Paraguaio',
    'Peruano',
    'Portorriquenho',
    'Dominicana',
    'São-cristovense',
    'São-vicentino',
    'Santa-lucense',
    'Surinamês',
    'Trindadense',
    'Uruguaio',
    'Venezuelano',
    'Alemã',
    'Austríac',
    'Belga',
    'Croata',
    'Dinamarquês',
    'Antiguano',
    'Argentino',
    'Bahamense',
    'barbadense',
    'Belizenho',
    'Eslovaco',
    'Esloveno',
    'Espanhol',
    'Francês',
    'Grego',
    'Húngaro',
    'Irlandês',
    'Italiano',
    'Noruego',
    'Holandês',
    'Polonês',
    'Inglês',
    'Galês',
    'Escocês',
    'Romeno',
    'Russo',
    'Sérvio',
    'Sueco',
    'Suíço',
    'Turco',
    'Ucraniano',
    'Americano',
    'Canadense',
    'Angolano',
    'Moçambicano',
    'Sul-africano',
    'Zimbabuense',
    'Argélia',
    'Comorense',
    'Egípcio',
    'Líbio',
    'Marroquino',
    'Ganés',
    'Queniano',
    'Ruandês',
    'Ugandense',
    'Bechuano',
    'Marfinense',
    'Camaronense',
    'Nigeriano',
    'Somali',
    'Australiano',
    'Neozelandês',
    'Afegão',
    'Saudita',
    'Armeno',
    'Bangladesh',
    'Chinês',
    'Norte-coreano',
    'Sul-coreano',
    'Indiano',
    'Indonésio',
    'Iraquiano',
    'Iraniano',
    'Israelita',
    'Japonês',
    'Malaio',
    'Nepalês',
    'Omanense',
    'Paquistanês',
    'Palestino',
    'Qatarense',
    'Sírio',
    'Cingalês',
    'Tailandês',
    'Timorense',
    'Árabe',
    'Vietnamita',
    'Iemenita',
  ];

  states: any[] = [
    { value: 'AC', name: 'Acre' },
    { value: 'AL', name: 'Alagoas' },
    { value: 'AP', name: 'Amapá' },
    { value: 'AM', name: 'Amazonas' },
    { value: 'BA', name: 'Bahia' },
    { value: 'CE', name: 'Ceará' },
    { value: 'DF', name: 'Distrito Federal' },
    { value: 'ES', name: 'Espírito Santo' },
    { value: 'GO', name: 'Goiás' },
    { value: 'MA', name: 'Maranhão' },
    { value: 'MT', name: 'Mato Grosso' },
    { value: 'MS', name: 'Mato Grosso do Sul' },
    { value: 'MG', name: 'Minas Gerais' },
    { value: 'PA', name: 'Pará' },
    { value: 'PB', name: 'Paraíba' },
    { value: 'PR', name: 'Paraná' },
    { value: 'PE', name: 'Pernambuco' },
    { value: 'PI', name: 'Piauí' },
    { value: 'RJ', name: 'Rio de Janeiro' },
    { value: 'RN', name: 'Rio Grande do Norte' },
    { value: 'RS', name: 'Rio Grande do Sul' },
    { value: 'RO', name: 'Rondônia' },
    { value: 'RR', name: 'Roraima' },
    { value: 'SC', name: 'Santa Catarina' },
    { value: 'SP', name: 'São Paulo' },
    { value: 'SE', name: 'Sergipe' },
    { value: 'TO', name: 'Tocantins' },
  ];

  specialties: any;
  occupationAreas: any;
  professionalId: string;
  isRegisterLoading = false;

  progressFilesUpload: any = {
    requestLetter: 0,
    idSizePhoto: 0,
    curriculum: 0,
    proofAddress: 0,
    vaccineCard: 0,
    crmCard: 0,
    annuityDischarge: 0,
    ethicsCertificate: 0,
    qplsOrAclsCertificate: 0,
    graduationCertificate: 0,
    ethicalBackgroundStatement: 0,
    medicineCertificate: 0,
    medicalResidencyCertificate: 0,
  };

  professionalForm: FormGroup = new FormGroup({
    fullname: new FormControl(''),
    email: new FormControl(''),
    genre: new FormControl(''),
    civilStatus: new FormControl(''),
    document: new FormControl(''),
    identity: new FormControl(''),
    identityAgency: new FormControl(''),
    identityDate: new FormControl(''),
    identityUf: new FormControl(''),
    nationality: new FormControl(''),
    citizenship: new FormControl(''),
    birthplace: new FormControl(''),
    licenseNumber: new FormControl(''),
    rqe: new FormControl(''),
    majorMedicalSpecialty: new FormControl(''),
    otherSpecialties: new FormControl(''),
    occupationArea: new FormControl(''),
    phone: new FormGroup({
      cellphone: new FormControl(''),
      phone: new FormControl(''),
    }),
    birthdate: new FormControl(''),
    fatherName: new FormControl(''),
    motherName: new FormControl(''),
    voterRegistration: new FormControl(''),
    pis: new FormControl(''),
    employmentType: new FormControl('service_provider'),
  });

  addressForm: FormGroup = new FormGroup({
    street: new FormControl(''),
    number: new FormControl(''),
    neighborhood: new FormControl(''),
    complement: new FormControl(''),
    city: new FormControl(''),
    zipcode: new FormControl(''),
    state: new FormControl(''),
  });

  bankForm: FormGroup = new FormGroup({
    name: new FormControl(''),
    agency: new FormControl(''),
    account: new FormControl(''),
    typeAccount: new FormControl(''),
    accountType: new FormControl(''),
    keyPix: new FormControl(''),
  });

  constructor(
    private formBuilder: FormBuilder,
    private professionalService: ProfessionalService,
    private specialtiesService: SpecialtiesService,
    private occupationAreasService: OccupationAreasService,
    private zipcodeService: ZipcodeService,
    private uploadService: UploadService,
    private router: Router,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit() {
    this.specialtiesService
      .getAll()
      .pipe(take(1))
      .subscribe((data) => (this.specialties = data));
    this.occupationAreasService
      .getAll()
      .pipe(take(1))
      .subscribe((data) => (this.occupationAreas = data));

    this.professionalForm = this.formBuilder.group({
      fullname: [
        '',
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(255),
        ],
      ],
      email: [
        '',
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(80),
        ],
      ],
      genre: ['', [Validators.required]],
      civilStatus: ['', [Validators.required]],
      document: ['', [Validators.required]],
      identity: ['', [Validators.required]],
      identityAgency: ['', [Validators.required]],
      identityDate: ['', [Validators.required]],
      identityUf: ['', [Validators.required]],
      nationality: ['', [Validators.required]],
      citizenship: ['', [Validators.required]],
      birthplace: ['', [Validators.required]],
      licenseNumber: ['', [Validators.required]],
      rqe: [''],
      majorMedicalSpecialty: ['', [Validators.required]],
      otherSpecialties: [''],
      occupationArea: ['', [Validators.required]],
      phone: this.formBuilder.group({
        cellphone: ['', [Validators.required]],
        phone: [''],
      }),
      birthdate: ['', [Validators.required]],
      fatherName: ['', [Validators.required]],
      motherName: ['', [Validators.required]],
      voterRegistration: ['', [Validators.required]],
      pis: ['', [Validators.required]],
      password: ['', [Validators.required, Validators.min(6)]],
      confirmPassword: ['', [Validators.required, Validators.min(6)]],
      type: ['', [Validators.required]],
      numberHealth: ['', [Validators.required]],
      bloodType: ['', [Validators.required]]
    });

    this.addressForm = this.formBuilder.group({
      street: ['', [Validators.required]],
      number: ['', [Validators.required]],
      neighborhood: ['', [Validators.required]],
      complement: [''],
      city: ['', [Validators.required]],
      zipcode: ['', [Validators.required, Validators.minLength(8)]],
      state: ['', [Validators.required]],
    });

    this.bankForm = this.formBuilder.group({
      name: ['', [Validators.required]],
      agency: ['', [Validators.required]],
      account: ['', [Validators.required]],
      typeAccount: ['', [Validators.required]],
      accountType: ['', [Validators.required]],
      keyPix: ['', [Validators.required]],
    });


    this.addressForm
      .get('zipcode')
      ?.statusChanges.pipe(
        distinctUntilChanged(),
        tap((value) => console.log('---->', value)),
        switchMap((status) =>
          status === 'VALID'
            ? this.zipcodeService.search(this.addressForm.get('zipcode')?.value)
            : of()
        )
      )
      .subscribe((data) => (data ? this.setDataZipcode(data) : {}));
  }


  hasErrorProfessional(controlName: string, errorName: string) {
    return this.professionalForm.controls[controlName].hasError(errorName);
  }

  hasErrorAddress(controlName: string, errorName: string) {
    return this.addressForm.controls[controlName].hasError(errorName);
  }

  hasErrorBank(controlName: string, errorName: string) {
    return this.bankForm.controls[controlName].hasError(errorName);
  }

  formatAccountNumber(event: any) {
    let value = event.target.value;
    const numericValue = value.replace(/\D/g, '');

    if (numericValue.length >= 2) {
      value = numericValue.slice(0, -1) + '-' + numericValue.slice(-1);
    } else {
      value = numericValue;
    }

    this.bankForm.patchValue({ account: value });
  }

  private removeAccountMask(value: string): string {
    return value.replace(/\D/g, '');
  }

  getNameSpecialties(specialties: any[]) {
    return (
      specialties.length > 0 && specialties.map((specialty) => specialty.name)
    );
  }

  onSubmit() {
    this.isRegisterLoading = true;
    this.snackBar.open(
      'Aguarde... enquanto registramos o professional!',
      'OK',
      {
        duration: 2000,
      }
    );

    const data = {
      professional: {
        fullname: this.professionalForm.value.fullname,
        email: this.professionalForm.value.email,
        genre: this.professionalForm.value.genre,
        civilStatus: this.professionalForm.value.civilStatus,
        document: this.professionalForm.value.document,
        identity: this.professionalForm.value.identity.toString(),
        identityAgency: this.professionalForm.value.identityAgency,
        identityDate: this.professionalForm.value.identityDate,
        identityUf: this.professionalForm.value.identityUf.value,
        nationality: this.professionalForm.value.nationality,
        birthplace: this.professionalForm.value.birthplace,
        licenseNumber: this.professionalForm.value.licenseNumber,
        rqe: this.professionalForm.value.rqe ? this.professionalForm.value.rqe.toString() : ' ',
        citizenship: this.professionalForm.value.citizenship.value,
        birthdate: this.professionalForm.value.birthdate,
        fatherName: this.professionalForm.value.fatherName,
        motherName: this.professionalForm.value.motherName,
        voterRegistration: this.professionalForm.value.voterRegistration,
        pis: this.professionalForm.value.pis.toString(),
        type: this.professionalForm.value.type,
        employmentType: this.professionalForm.value.employmentType || 'service_provider',
      },
      majorMedicalSpecialty: this.professionalForm.value.majorMedicalSpecialty,
      occupationArea: this.professionalForm.value.occupationArea,
      otherSpecialties: this.professionalForm.value.otherSpecialties ? this.professionalForm.value.otherSpecialties : ' ',
      phone: {
        phone: this.professionalForm.value.phone.phone ? this.professionalForm.value.phone.phone.replace(/\D+/g, '') : ' ',
        cellphone: this.professionalForm.value.phone.cellphone.replace(/\D+/g, ''),
      },
      address: this.addressForm.value,
      bank: {
        ...this.bankForm.value,
        account: this.removeAccountMask(this.bankForm.value.account),
        agency: this.bankForm.value.agency.toString()
      },
      password: this.professionalForm.value.password.toString(),
    };

    this.professionalService.register(data).subscribe({
      next: (result: any) => {
        this.isRegisterLoading = false;
        this.professionalId = result.professionalId;
        this.professionalForm.reset();
        this.addressForm.reset();
        this.bankForm.reset();
         this.snackBar.open(
          'Profissional cadastrado com sucesso!',
          'OK',
          {
            duration: 5000,
          }
        );
        this.router.navigateByUrl(`/professionals/${this.professionalId}#documents`);
      },
      error: (error) => {
        this.isRegisterLoading = false;
        this.snackBar.open(
          'Não foi possível cadastrar o médico, tente novamente mais tarde!',
          'OK',
          {
            duration: 3000,
          }
        );
      },
    });
  }

  private setDataZipcode(data: any) {
    this.addressForm.patchValue({
      street: data.logradouro,
      neighborhood: data.bairro,
      city: data.localidade,
      state: data.uf,
      complement: data.complemento,
    });
  }
}
